import {blue} from "@mui/material/colors";
import {NavLink} from "react-router-dom";
import {Typography} from "@mui/material";

export default function ObjectLinked({pathname, value, sx}: { pathname: string, value: string, sx?: any }) {
    return (
        <Typography
            fontSize={13}
            my="auto"
            color={blue[900]}
            sx={{
                "&:hover": {color: blue[900]},
                ...sx
            }}
            component={NavLink}
            to={{pathname}}
        >
            {value}
        </Typography>
    )
}